import{a as r,m as n}from"./chunk-HBP5N4FR.js";n();function P(t,s){let e=new URLSearchParams(t),a=Object.fromEntries(e);return{nextUrlParams:new URLSearchParams(r(r({},a),s)).toString(),params:a}}export{P as a};
//# sourceMappingURL=chunk-JFXVZGSY.js.map
